import * as React from 'react'
import { createComponent } from '@cloudflare/style-container'

type TCodeKeys = '1' | '2' | '3' | '4' | '5'
export const RequestStatusCodeIndicator = createComponent(
  ({ statusCode, theme }: { statusCode: number; theme: any }) => ({
    display: 'inline-block',
    borderRadius: '100%',
    width: '12px',
    height: '12px',
    background: (() => {
      const code = statusCode.toString()
      return (
        {
          '1': theme.colors.green[5],
          '2': theme.colors.green[5],
          '3': theme.colors.orange[6],
          '4': theme.colors.red[3],
          '5': theme.colors.red[3],
        }[code[0] as TCodeKeys] || 'gray'
      )
    })(),
  }),
)



// WEBPACK FOOTER //
// ./node_modules/@cloudflare/cf-component-request-status-indicator/src/RequestStatusCodeIndicator.tsx